import React, { FC, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { EnrolmentDevice } from "../../models/EnrolmentDevices";
import { EnrolmentTask } from "../../models/EnrolmentTask";
import { PluginCommand } from "../../models/PluginCommand";
import SystemEnrolmentDevice from "../../models/SystemEnrolmentDevice";
import { IShowEnrollValidOptions } from "../../services/wsPluginService/plugins/base/pluginModels";
import EmptyTableState from "../emptyTableState/EmptyTableState";
import List from '../list/list';

interface Props {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    enrollMethod: string;
    pluginsAvailable?: IShowEnrollValidOptions;
    availableSystemDeviceIds?: number[];
}

const SubTasksForm: FC<Props> = ({ onNext, onBack, enrollMethod, pluginsAvailable, availableSystemDeviceIds }) => {
    const [taskSelected, setTaskSelected] = useState(false);
    const [task, setTask] = useState('');
    const { translate } = useLocale();
    const enrolmentDevice = new EnrolmentDevice(translate);
    const enrolmentTask = new EnrolmentTask(translate);

    const getAllDevices = (pluginsAvailable?: IShowEnrollValidOptions, availableSystemDeviceIds?: number[]) => {
        let allDevices: any[] = [];
        let plugins: PluginCommand[] = [];
        let devices: SystemEnrolmentDevice[] = [];

        if (enrollMethod === enrolmentTask.ENROL_CARD.value) {
            allDevices.push(enrolmentDevice.MANUAL_CODE_TYPE);
            allDevices.push(enrolmentDevice.RANDOM_PAC);
            plugins = enrolmentDevice.ENROL_CARD_PLUGIN;
            devices = enrolmentDevice.ENROL_CARD_DEVICES;
        } else if (enrollMethod === enrolmentTask.ENROL_FACE.value) {
            plugins = enrolmentDevice.ENROL_FACE_PLUGIN;
            devices = enrolmentDevice.ENROL_FACE_DEVICES;
        } else if (enrollMethod === enrolmentTask.ENROL_HAND.value) {
            plugins = enrolmentDevice.ENROL_HAND_PLUGIN;
            devices = enrolmentDevice.ENROL_HAND_DEVICES;
        } else if (enrollMethod === enrolmentTask.ENROL_FINGERPRINT.value) {
            plugins = enrolmentDevice.ENROL_FINGER_PLUGIN;
            devices = enrolmentDevice.ENROL_FINGER_DEVICES;
        } else if (enrollMethod === enrolmentTask.ENROL_MOBILE_CREDENTIAL.value) {
            allDevices.push(enrolmentDevice.HID_MOBILE_ACCESS);
            allDevices.push(enrolmentDevice.STID_MOBILE);
        } else if (enrollMethod === enrolmentTask.ENCODE_CARD.value) {
            allDevices.push(enrolmentDevice.VINGCARD);
        }

        const availablePlugins = plugins.filter(plugin => plugin.type && pluginsAvailable?.hasOwnProperty(plugin.type) && pluginsAvailable[plugin.type] === true);
        const availableSystemDevice = devices.filter(device => availableSystemDeviceIds?.includes(device.id));
        allDevices.push(...availablePlugins)
        allDevices.push(...availableSystemDevice)

        return allDevices;
    };

    const allDevices = getAllDevices(pluginsAvailable, availableSystemDeviceIds)

    const onLocalNext = (event: any) => {
        if (event.task) {
            onNext({ ...event, task: event.task, description: event.description });
        }
    }

    const itemSelected = (item: any) => {
        const selectedItem = item.props['data-item'];
        if (selectedItem) {
            setTaskSelected(true);
            setTask(selectedItem.value);
            onLocalNext({task: selectedItem.value, description: selectedItem.label, setTaskSelected: setTaskSelected});
        }
    }

    const getListItems = (): { value: JSX.Element; isSelected: boolean; }[] => {
        return allDevices.map(item => {
            return {
                value: (
                    <div className="flex flex-row items-center cursor-pointer select-none" data-item={item}>
                        <div id={`subTask${item.label.split(' ').join('')}`} className="p-2">{item.label}</div>
                    </div>
                ),
                isSelected: item.value === task
            };
        })
    }

    return (<div className="pt-3 pr-3 flex flex-col h-full relative">
        <div className="flex-1 overflow-y-auto pr-1 mb-16">
            {allDevices.length > 0 ?
                <List onSelect={(_, item) => itemSelected(item)} isStriped items={getListItems()} />
                : <EmptyTableState message={translate.byKey(TranslationKeys.noEnrolmentDeviceFound)} hideAddNewButton={true} />
            }
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            {allDevices.length > 0 ?
                <div className="flex flex-row justify-end mt-4 pl-3">
                    <button
                        id="nextButton"
                        className={`py-1 px-5 secondary ${taskSelected ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                        type="button"
                        onClick={e => {
                            if (taskSelected) {
                                onLocalNext(e)
                            }
                        }}>
                        {translate.byKey(TranslationKeys.next)}
                    </button>
                </div> : null}
        </div>

    </div>)
}

export default SubTasksForm;
